<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row>
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <el-row>
        <el-select
          v-model="selectvalue"
          @change="rebuildChart('main')"
          style="width: 21%; margin-left: 0; padding: 0"
        >
          <el-option
            v-for="item in selectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="search"
          placeholder="検索ワードを入力"
          clearable
          style="width: 23%; margin-left: 10px; margin-right: 10px"
          @change="filterEchart()"
        ></el-input>
        <!-- <el-button
          icon="el-icon-sort"
          circle
          size="small"
          @click="sortList()"
        ></el-button> -->
        <span style="padding: 0 5px 0 5px">{{
          this.$root.htmlConst.cons_223_aggregate_period
        }}</span>
        <el-date-picker
            v-model="datePicker"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="〜"
            :picker-options="pickerOptions"
            @change="rebuildChart('main')"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            :clearable="false"
          >
          </el-date-picker>
      </el-row>
      <hr />
      <el-row>
        <echarts
          :autoresize="true"
          class="chart-view2"
          :option="option"
          @click="onClick"
          @legendselectchanged="legendselectchanged"
        />
      </el-row>
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold; margin-right: 10px">{{
              displayTitle
            }}</span>
          </el-row>
          <el-row>
            <el-select
              v-model="selectvalue"
              @change="rebuildChart('popup')"
              style="width: 21%; margin-left: 0; padding: 0"
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="search"
              placeholder="検索ワードを入力"
              clearable
              style="width: 23%; margin-left: 10px; margin-right: 10px"
              @change="filterEchart()"
            ></el-input>
            <!-- <el-button
              icon="el-icon-sort"
              circle
              size="small"
              @click="sortList()"
            ></el-button> -->
            <span style="padding: 0 5px 0 5px">{{
              this.$root.htmlConst.cons_223_aggregate_period
            }}</span>
            <el-date-picker
                v-model="datePicker"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="〜"
                :picker-options="pickerOptions"
                @change="rebuildChart('popup')"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                :clearable="false"
              >
              </el-date-picker>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
          @click="onClick"
          @legendselectchanged="legendselectchanged"
        />
      </el-dialog>
    </div>
  </el-col>
</template>


<script>
import api from "@/api";
var _ = require("lodash");
export default {
  name: "ChatbotQuestionChart",
  props: ["title", "displayTitle"],
  data() {
    let _this = this;
    return {
      option: this.option,
      loading: this.loading,
      popupLoading: this.popupLoading,
      popUpDisplay: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "Last Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() - 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() - 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Day",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Week",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 7);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 7);

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Next Month",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(new Date(_this.datePicker[0]).getTime() + 3600 * 1000 * 24 * 30);
              end.setTime(new Date(_this.datePicker[1]).getTime() + 3600 * 1000 * 24 * 30);

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      datePicker: [this.$root.startDate, this.$root.endDate],
      search: "",
      selectOptions: [
        {
          value: "上位10件",
          label: "上位10件",
        },
        {
          value: "上位20件",
          label: "上位20件",
        },
        {
          value: "上位100件",
          label: "上位100件",
        },
        {
          value: "下位10件",
          label: "下位10件",
        },
        {
          value: "下位20件",
          label: "下位20件",
        },
        {
          value: "下位100件",
          label: "下位100件",
        },
        {
          value: "全件",
          label: "全件",
        },
      ],
      selectvalue: "上位10件",
      data_list: [],
      titleList: [],
    };
  },
  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.datePicker = [startDate, endDate];
      this.rebuildChart("main");
    });
  },
  created() {
    let self = this;
    self.loading = true;

    api.getChatbotQuestionCount(self.datePicker[0],self.datePicker[1],self.selectvalue, self.$root.facetForEchart,self.$root.ageForEchart,self.$root.sexForEchart).then(
        (res) => {
          let data = res.data;
          self.data_list = data.output_list;
          self.titleList = data.titleList;
          self.option = {
            color: ["#67C23A", "#DDDDDD", "#F56C6C"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            legend: {
              data: ["高評価", "無評価", "低評価"],
              selected: {
                高評価: true,
                無評価: true,
                低評価: true,
              },
            },
            dataZoom: [
              {
                type: "slider",
                show: true,
                yAxisIndex: [0],
                showDetail: false,
                start: 100,
                end: self.computedPosition(
                  1,
                  self.data_list.highEvaluationList.length
                ),
                width: 10,
                fillerColor: "#269cdb",
                borderRadius: 5,
                showDataShadow: false,
                realtime: true,
                zoomLock: true,
                filterMode: "filter",
              },
              {
                type: "inside",
                yAxisIndex: 0,
                zoomOnMouseWheel: false,
                moveOnMouseMove: true,
                moveOnMouseWheel: true,
              },
            ],
            grid: {
              top: "8%",
              bottom: "10%",
              left: "5%",
              right: "5%",
            },
            xAxis: {
              type: "value",
              axisLabel: {
                formatter: function (value) {
                  return value;
                },
              },
            },
            yAxis: {
              type: "category",
              axisLabel: {
                inside: true,
                color: "#000055",
                z: 1,
              },
              data: self.titleList.map((v) => v.title),
            },
            series: [
              {
                name: "高評価",
                type: "bar",
                stack: "总量",
                barWidth: 40,
                barMaxWidth: 40,
                z: 0,
                data: self.data_list.highEvaluationList.map((v) => v.count),
              },
              {
                name: "無評価",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.noEvaluationList.map((v) => v.count),
              },
              {
                name: "低評価",
                type: "bar",
                stack: "总量",
                z: 0,
                data: self.data_list.lowEvaluationList.map((v) => v.count),
              },
            ],
          };
          self.loading = false;
        },
        (err) => {
          console.log(err);
        }
      );
  },
  methods: {
    legendselectchanged(params) {
      this.search = "";
      if (
        params.selected["高評価"] == true &&
        params.selected["無評価"] == true &&
        params.selected["低評価"] == true
      ) {
        this.option.legend.selected["高評価"] = true;
        this.option.legend.selected["無評価"] = true;
        this.option.legend.selected["低評価"] = true;
        this.option.series[0].data = this.data_list.highEvaluationList.map(
          (v) => v.count
        );
        this.option.series[1].data = this.data_list.noEvaluationList.map(
          (v) => v.count
        );
        this.option.series[2].data = this.data_list.lowEvaluationList.map(
          (v) => v.count
        );
        this.option.yAxis.data = this.titleList.map((v) => v.title);
      } else if (
        params.selected["高評価"] == true &&
        params.selected["無評価"] == true &&
        params.selected["低評価"] == false
      ) {
        this.option.legend.selected["高評価"] = true;
        this.option.legend.selected["無評価"] = true;
        this.option.legend.selected["低評価"] = false;
        let newAttr = [];
        for (var i = 0; i < this.data_list.highEvaluationList.length; i++) {
          let newOject = {
            count:
              parseInt(this.data_list.highEvaluationList[i].count) +
              parseInt(this.data_list.noEvaluationList[i].count),
            hightCount: this.data_list.highEvaluationList[i].count,
            noCount: this.data_list.noEvaluationList[i].count,
          };
          newAttr.push(newOject);
        }

        newAttr = _.sortBy(newAttr, function (o) {
          return o.count;
        });

        this.option.series[0].data = newAttr.map((v) => v.hightCount);
        this.option.series[1].data = newAttr.map((v) => v.noCount);
        this.option.series[2].data = [];

        let highEvaluationList = JSON.parse(
          JSON.stringify(this.data_list.highEvaluationList)
        );
        let noEvaluationList = JSON.parse(
          JSON.stringify(this.data_list.noEvaluationList)
        );
        this.option.yAxis.data = [];
        for (let i = 0; i < this.option.series[0].data.length; i++) {
          for (let j = 0; j < highEvaluationList.length; j++) {
            if (
              this.option.series[0].data[i] == highEvaluationList[j].count &&
              this.option.series[1].data[i] == noEvaluationList[j].count
            ) {
              this.option.yAxis.data.push(highEvaluationList[j].title);
              highEvaluationList.splice(j, 1);
              noEvaluationList.splice(j, 1);
              break;
            }
          }
        }
      } else if (
        params.selected["高評価"] == true &&
        params.selected["無評価"] == false &&
        params.selected["低評価"] == true
      ) {
        this.option.legend.selected["高評価"] = true;
        this.option.legend.selected["無評価"] = false;
        this.option.legend.selected["低評価"] = true;
        let newAttr = [];
        for (let i = 0; i < this.data_list.highEvaluationList.length; i++) {
          let newOject = {
            count:
              parseInt(this.data_list.highEvaluationList[i].count) +
              parseInt(this.data_list.lowEvaluationList[i].count),
            hightCount: this.data_list.highEvaluationList[i].count,
            lowCount: this.data_list.lowEvaluationList[i].count,
          };
          newAttr.push(newOject);
        }

        newAttr = _.sortBy(newAttr, function (o) {
          return o.count;
        });

        this.option.series[0].data = newAttr.map((v) => v.hightCount);
        this.option.series[1].data = [];
        this.option.series[2].data = newAttr.map((v) => v.lowCount);

        let highEvaluationList = JSON.parse(
          JSON.stringify(this.data_list.highEvaluationList)
        );
        let lowEvaluationList = JSON.parse(
          JSON.stringify(this.data_list.lowEvaluationList)
        );
        this.option.yAxis.data = [];
        for (let i = 0; i < this.option.series[0].data.length; i++) {
          for (let j = 0; j < highEvaluationList.length; j++) {
            if (
              this.option.series[0].data[i] == highEvaluationList[j].count &&
              this.option.series[2].data[i] == lowEvaluationList[j].count
            ) {
              this.option.yAxis.data.push(highEvaluationList[j].title);
              highEvaluationList.splice(j, 1);
              lowEvaluationList.splice(j, 1);
              break;
            }
          }
        }
      } else if (
        params.selected["高評価"] == false &&
        params.selected["無評価"] == true &&
        params.selected["低評価"] == true
      ) {
        this.option.legend.selected["高評価"] = false;
        this.option.legend.selected["無評価"] = true;
        this.option.legend.selected["低評価"] = true;
        let newAttr = [];
        for (let i = 0; i < this.data_list.noEvaluationList.length; i++) {
          let newOject = {
            count:
              parseInt(this.data_list.noEvaluationList[i].count) +
              parseInt(this.data_list.lowEvaluationList[i].count),
            noCount: this.data_list.noEvaluationList[i].count,
            lowCount: this.data_list.lowEvaluationList[i].count,
          };
          newAttr.push(newOject);
        }

        newAttr = _.sortBy(newAttr, function (o) {
          return o.count;
        });

        this.option.series[0].data = [];
        this.option.series[1].data = newAttr.map((v) => v.noCount);
        this.option.series[2].data = newAttr.map((v) => v.lowCount);

        let noEvaluationList = JSON.parse(
          JSON.stringify(this.data_list.noEvaluationList)
        );

        let lowEvaluationList = JSON.parse(
          JSON.stringify(this.data_list.lowEvaluationList)
        );
        this.option.yAxis.data = [];
        for (let i = 0; i < this.option.series[1].data.length; i++) {
          for (let j = 0; j < noEvaluationList.length; j++) {
            if (
              this.option.series[1].data[i] == noEvaluationList[j].count &&
              this.option.series[2].data[i] == lowEvaluationList[j].count
            ) {
              this.option.yAxis.data.push(noEvaluationList[j].title);
              noEvaluationList.splice(j, 1);
              lowEvaluationList.splice(j, 1);
              break;
            }
          }
        }
      } else if (
        params.selected["高評価"] == false &&
        params.selected["無評価"] == false &&
        params.selected["低評価"] == true
      ) {
        this.option.legend.selected["高評価"] = false;
        this.option.legend.selected["無評価"] = false;
        this.option.legend.selected["低評価"] = true;
        this.option.series[0].data = [];
        this.option.series[1].data = [];
        this.option.series[2].data = this.data_list.lowEvaluationList
          .map((v) => v.count)
          .sort(function (a, b) {
            return a - b;
          });
        let lowEvaluationList = JSON.parse(
          JSON.stringify(this.data_list.lowEvaluationList)
        );
        this.option.yAxis.data = [];
        for (let count of this.option.series[2].data) {
          for (let [index, evaluation] of lowEvaluationList.entries()) {
            if (count == evaluation.count) {
              this.option.yAxis.data.push(evaluation.title);
              lowEvaluationList.splice(index, 1);
              break;
            }
          }
        }
      } else if (
        params.selected["高評価"] == true &&
        params.selected["無評価"] == false &&
        params.selected["低評価"] == false
      ) {
        this.option.legend.selected["高評価"] = true;
        this.option.legend.selected["無評価"] = false;
        this.option.legend.selected["低評価"] = false;
        this.option.series[0].data = this.data_list.highEvaluationList
          .map((v) => v.count)
          .sort(function (a, b) {
            return a - b;
          });
        this.option.series[1].data = [];
        this.option.series[2].data = [];
        let highEvaluationList = JSON.parse(
          JSON.stringify(this.data_list.highEvaluationList)
        );
        this.option.yAxis.data = [];
        for (let count of this.option.series[0].data) {
          for (let [index, evaluation] of highEvaluationList.entries()) {
            if (count == evaluation.count) {
              this.option.yAxis.data.push(evaluation.title);
              highEvaluationList.splice(index, 1);
              break;
            }
          }
        }
      } else if (
        params.selected["高評価"] == false &&
        params.selected["無評価"] == true &&
        params.selected["低評価"] == false
      ) {
        this.option.legend.selected["高評価"] = false;
        this.option.legend.selected["無評価"] = true;
        this.option.legend.selected["低評価"] = false;
        this.option.series[0].data = [];
        this.option.series[1].data = this.data_list.noEvaluationList
          .map((v) => v.count)
          .sort(function (a, b) {
            return a - b;
          });
        this.option.series[2].data = [];
        let noEvaluationList = JSON.parse(
          JSON.stringify(this.data_list.noEvaluationList)
        );
        this.option.yAxis.data = [];
        for (let count of this.option.series[1].data) {
          for (let [index, evaluation] of noEvaluationList.entries()) {
            if (count == evaluation.count) {
              this.option.yAxis.data.push(evaluation.title);
              noEvaluationList.splice(index, 1);
              break;
            }
          }
        }
      } else {
        this.option.legend.selected["高評価"] = false;
        this.option.legend.selected["無評価"] = false;
        this.option.legend.selected["低評価"] = false;
        this.option.series[0].data = [];
        this.option.series[1].data = [];
        this.option.series[2].data = [];
        this.option.yAxis.data = this.titleList.map((v) => v.title);
      }
    },
    sortList() {
      this.titleList = _.reverse(this.titleList);
      this.data_list.highEvaluationList = _.reverse(
        this.data_list.highEvaluationList
      );
      this.data_list.lowEvaluationList = _.reverse(
        this.data_list.lowEvaluationList
      );
      this.data_list.noEvaluationList = _.reverse(
        this.data_list.noEvaluationList
      );
      this.option = {
        color: ["#67C23A", "#DDDDDD", "#F56C6C"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["高評価", "無評価", "低評価"],
          selected: {
            高評価: true,
            無評価: true,
            低評価: true,
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            yAxisIndex: [0],
            showDetail: false,
            start: 100,
            end: this.computedPosition(
              1,
              this.data_list.highEvaluationList.length
            ),
            width: 10,
            fillerColor: "#269cdb",
            borderRadius: 5,
            showDataShadow: false,
            realtime: true,
            zoomLock: true,
            filterMode: "filter",
          },
          {
            type: "inside",
            yAxisIndex: 0,
            zoomOnMouseWheel: false,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
        grid: {
          top: "8%",
          bottom: "10%",
          left: "5%",
          right: "5%",
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return value;
            },
          },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            inside: true,
            color: "#000055",
            z: 1,
          },
          data: this.titleList.map((v) => v.title),
        },
        series: [
          {
            name: "高評価",
            type: "bar",
            stack: "总量",
            barWidth: 40,
            barMaxWidth: 40,
            z: 0,
            data: this.data_list.highEvaluationList.map((v) => v.count),
          },
          {
            name: "無評価",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.noEvaluationList.map((v) => v.count),
          },
          {
            name: "低評価",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.lowEvaluationList.map((v) => v.count),
          },
        ],
      };
    },
    computedPosition(length, xArraylength) {
      if (xArraylength > 5) {
        return 104 - (5 / xArraylength) * 100;
      } else {
        return 0;
      }
    },
    onClick(params) {
      this.search = "";
      let ageAndSexStr = '';
      if (this.$root.ageForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_89&op%5Bcf_89%5D=~&v%5Bcf_89%5D%5B%5D=" + this.$root.ageForEchart[0];
      }
      if (this.$root.sexForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_90&op%5Bcf_90%5D=~&v%5Bcf_90%5D%5B%5D=" + this.$root.sexForEchart[0];
      }
      if (params.seriesName == "低評価") {
        window.open(
          this.$root.redmineUrl +
            "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=2&f%5B%5D=cf_25&op%5Bcf_25%5D=%3D&v%5Bcf_25%5D%5B%5D=" +
            this.titleList[params.dataIndex].document_id +
            "&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[0] +
            "&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[1] +
            "&f%5B%5D=cf_6&op%5Bcf_6%5D=%3E%3C&v%5Bcf_6%5D%5B%5D=0&v%5Bcf_6%5D%5B%5D=5&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
            + ageAndSexStr
        );
      } else if (params.seriesName == "高評価") {
        window.open(
          this.$root.redmineUrl +
            "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=2&f%5B%5D=cf_25&op%5Bcf_25%5D=%3D&v%5Bcf_25%5D%5B%5D=" +
            this.titleList[params.dataIndex].document_id +
            "&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[0] +
            "&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[1] +
            "&f%5B%5D=cf_6&op%5Bcf_6%5D=%3E%3C&v%5Bcf_6%5D%5B%5D=6&v%5Bcf_6%5D%5B%5D=10&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
            + ageAndSexStr
        );
      } else {
        window.open(
          this.$root.redmineUrl +
            "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=2&f%5B%5D=cf_25&op%5Bcf_25%5D=%3D&v%5Bcf_25%5D%5B%5D=" +
            this.titleList[params.dataIndex].document_id +
            "&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[0] +
            "&v%5Bcreated_on%5D%5B%5D=" +
            this.datePicker[1] +
            "&f%5B%5D=cf_6&op%5Bcf_6%5D=%21*&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D="
            + ageAndSexStr
        );
      }
    },
    filterEchart() {
      this.option = {
        color: ["#67C23A", "#DDDDDD", "#F56C6C"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["高評価", "無評価", "低評価"],
          selected: {
            高評価: true,
            無評価: true,
            低評価: true,
          },
        },

        dataZoom: [
          {
            type: "slider",
            show: true,
            yAxisIndex: [0],
            showDetail: false,
            start: 100,
            end: this.computedPosition(
              1,
              this.data_list.highEvaluationList.length
            ),
            width: 10,
            fillerColor: "#269cdb",
            borderRadius: 5,
            showDataShadow: false,
            realtime: true,
            zoomLock: true,
            filterMode: "filter",
          },
          {
            type: "inside",
            yAxisIndex: 0,
            zoomOnMouseWheel: false,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
        grid: {
          top: "8%",
          bottom: "10%",
          left: "5%",
          right: "5%",
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return value;
            },
          },
        },
        yAxis: {
          type: "category",
          axisLabel: {
            inside: true,
            color: "#000055",
            z: 1,
          },
          data: this.titleList
            .filter(
              (data) =>
                !this.search ||
                data.title.toLowerCase().includes(this.search.toLowerCase())
            )
            .map((v) => v.title),
        },
        series: [
          {
            name: "高評価",
            type: "bar",
            stack: "总量",
            barWidth: 40,
            barMaxWidth: 40,
            z: 0,
            data: this.data_list.highEvaluationList
              .filter(
                (data) =>
                  !this.search ||
                  data.title.toLowerCase().includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "無評価",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.noEvaluationList
              .filter(
                (data) =>
                  !this.search ||
                  data.title.toLowerCase().includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
          {
            name: "低評価",
            type: "bar",
            stack: "总量",
            z: 0,
            data: this.data_list.lowEvaluationList
              .filter(
                (data) =>
                  !this.search ||
                  data.title.toLowerCase().includes(this.search.toLowerCase())
              )
              .map((v) => v.count),
          },
        ],
      };
    },
    showPopUp() {
      this.popUpDisplay = true;
    },
    rebuildChart(value) {
      this.search = "";
      let self = this;
      if (value == "main") {
        self.loading = true;
      } else {
        self.popupLoading = true;
      }

      api.getChatbotQuestionCount(self.datePicker[0], self.datePicker[1], self.selectvalue, self.$root.facetForEchart,self.$root.ageForEchart,self.$root.sexForEchart).then(
          (res) => {
            let data = res.data;
            self.data_list = data.output_list;
            self.titleList = data.titleList;
            self.option = {
              color: ["#67C23A", "#DDDDDD", "#F56C6C"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              legend: {
                data: ["高評価", "無評価", "低評価"],
                selected: {
                  高評価: true,
                  無評価: true,
                  低評価: true,
                },
              },
              dataZoom: [
                {
                  type: "slider",
                  show: true,
                  yAxisIndex: [0],
                  showDetail: false,
                  start: 100,
                  end: self.computedPosition(
                    1,
                    self.data_list.highEvaluationList.length
                  ),
                  width: 10,
                  fillerColor: "#269cdb",
                  borderRadius: 5,
                  showDataShadow: false,
                  realtime: true,
                  zoomLock: true,
                  filterMode: "filter",
                },
                {
                  type: "inside",
                  yAxisIndex: 0,
                  zoomOnMouseWheel: false,
                  moveOnMouseMove: true,
                  moveOnMouseWheel: true,
                },
              ],
              grid: {
                top: "8%",
                bottom: "10%",
                left: "5%",
                right: "5%",
              },
              xAxis: {
                type: "value",
                axisLabel: {
                  formatter: function (value) {
                    return value;
                  },
                },
              },
              yAxis: {
                type: "category",
                axisLabel: {
                  inside: true,
                  color: "#000055",
                  z: 1,
                },
                data: self.titleList.map((v) => v.title),
              },
              series: [
                {
                  name: "高評価",
                  type: "bar",
                  stack: "总量",
                  barWidth: 40,
                  barMaxWidth: 40,
                  z: 0,
                  data: self.data_list.highEvaluationList.map((v) => v.count),
                },
                {
                  name: "無評価",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.noEvaluationList.map((v) => v.count),
                },
                {
                  name: "低評価",
                  type: "bar",
                  stack: "总量",
                  z: 0,
                  data: self.data_list.lowEvaluationList.map((v) => v.count),
                },
              ],
            };
            if (value == "main") {
              self.loading = false;
            } else {
              self.popupLoading = false;
            }
          },
          (err) => {
            console.log(err);
          }
        );
    },
  },
};
</script>
<style>
.el-input__inner {
  height: 35px;
  line-height: 35px;
}
</style>